import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    partnerRoles: [],
    partnerSkills: [],
    userLanguages: [],
    equipmenttype:[]
};

const siteDataSlice = createSlice({
    name: "siteData",
    initialState,
    reducers: {
        setPartnerRoles(state, action) {
            state.partnerRoles = action.payload;
        },
        setPartnerSkills(state, action) {
            state.partnerSkills = action.payload;
        },
        setUserLanguages(state, action) {
            state.userLanguages = action.payload;
        },
        setEquipmentType(state, action){
            state.equipmenttype = action.payload;
        }
    },
});

export const { setPartnerRoles, setPartnerSkills, setUserLanguages, setEquipmentType } = siteDataSlice.actions;

export default siteDataSlice.reducer;
